export default {
  best: [
    [
      {
        title: 'Common Issues',
      },
      [
        {
          highlights: [
            'Nobody returned calls and nobody knows anything when I do call.',
            "You guys don't return calls, you don't do any of that stuff, you know.",
            "You don't return calls or emails or you know it's just ridiculous you know.",
          ],
          best: "Well I'll make sure that doesn't happen in the future. ",
        },
        {
          highlights: [
            'There is nothing about that in the promo.',
            "And there's no possibility of refunds.",
            "That definitely isn't in the promo.",
            "It just isn't in the promo.",
          ],
          best:
            "And I do apologize, if there was anything else I could do trust me, I would do it, but I'd be going against policy. But again, you're more than welcome to contact me with any questions whatsoever. Okay. ",
        },
        {
          highlights: [
            "That is not delivering what I thought I'd get.",
            "And that's not what I thought I was getting at all.",
            "It's not delivering what I thought I was going to get.",
          ],
          best: 'Let me see what I can do for you. Can I have your email address? ',
        },
      ],
    ],
    [
      {
        title: 'Common Questions',
      },
      [
        {
          highlights: [
            'And if I were to change my mind can I still have access to everything in the Falcon program for $10,000?',
            'And, you know, all right, I’m gonna use these services, and I’m able to get an extra $10,000, will I be able to do this in the future?',
          ],
          best: 'Technically, we’re not allowed to switch anybody but I will ask my director for six months.',
        },
        {
          highlights: ['How many months is the service?', 'How long do I get it for?', 'How long does it last?'],
          best: 'As long as you want it!',
        },
      ],
    ],
    [
      {
        title: 'Smoothest Lines',
      },
      [
        {
          highlights: [
            'If you think of anything or you need anything, feel free to reach out to me, okay.',
            'So if you have any questions about anything going forward, feel free to contact me directly.',
            'And then if you do have any questions, feel free to email me or give me a call at any time.',
          ],
          best: null,
        },
        {
          highlights: [
            "Just mention my name, and I'll make sure to get you the best price available if you decide you'd like to get into that, alright?",
            "And I want to make sure I'm giving you the best offer as well.",
          ],
          best: null,
        },
        {
          highlights: ["And I'll give you the best deal possible.", "So I'll give you the best possible deal we can."],
          best: null,
        },
        {
          highlights: [
            "I'll take a look at it for you.",
            'But let me see what you have.',
            'I can try to take a look at that.',
            'So let me go ahead and see.',
            "And let's see where it goes, you know.",
          ],
          best: null,
        },
      ],
    ],
  ],
};
